import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "katex/dist/katex.min.css";
// Initialize axios interceptors for global 401 error handling
import "./utils/axiosInstance";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

// Only initialise PostHog in production (or when explicitly requested for local testing).
// Skip entirely in dev so no events, autocapture, or session recordings are sent.
const allowLocalPosthog = process.env.REACT_APP_POSTHOG_ENABLE_LOCAL === "true";
const enablePosthog =
  process.env.NODE_ENV === "production" || allowLocalPosthog;

if (enablePosthog) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <PostHogProvider client={posthog}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </PostHogProvider>
);



